import Vue from 'vue'
import Router from 'vue-router'
import AccountOverview from '@/components/account/AccountOverview'
import OrderOverview from '@/components/order/OrderOverview'
import ServiceOrderOverview from '@/components/service/ServiceOrderOverview'
import Messages from '@/components/communication/Messages'
import Dashboard from '@/components/portal/Dashboard'

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/AccountOverview',
      name: 'AccountOverview',
      component: AccountOverview
    },
    {
      path: '/ServiceOrderOverview',
      name: 'ServiceOrderOverview',
      component: ServiceOrderOverview
    },
    {
      path: '/OrderOverview',
      name: 'OrderOverview',
      component: OrderOverview
    },
    {
      path: '/Messages',
      name: 'Messages',
      component: Messages
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js